import { LupaIcon } from "assets/icons/LupaIcon";
import { showErrorToast } from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { Pagination } from "components/Pagination/Pagination";
import { DEFAULT_LIMIT_PAGINATION } from "constants/appConstants";
import { useFormik } from "formik";
import { CertificacionI } from "interfaces/Certificacion";
import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCertificaciones } from "services/certificacion";
import { AppDispatch } from "store/store";
import { CertificacionesABM } from "./CertificacionesABM/CertificacionesABM";
import { CertificacionesTable } from "./CertificacionesTable/CertificacionesTable";
import { CertificacionesRowActions } from "./CertificacionesTable/CertificacionesRowActions";

export const Certificaciones = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [elementos, setElementos] = useState<CertificacionI[]>();
  const [cantidad, setCantidad] = useState<number>();
  const [page, setPage] = useState<number>();
  const [limit, setLimit] = useState<number>();

  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();

  const [showModalABM, setShowModalABM] = useState(false);
  const [actionType, setActionType] = useState<"create" | "edit" | undefined>();
  const [selectedElement, setSelectedElement] = useState<
    CertificacionI | undefined
  >();

  const initialValues = {
    nombre: "",
    descripcion: "",
  };

  const { values, handleChange, resetForm } = useFormik({
    initialValues,
    onSubmit: () => {},
  });

  const searchOrientaciones = async (params?: {
    filtros?: { [key: string]: any };
  }) => {
    try {
      setIsLoading(true);
      const response = await getCertificaciones({ ...params?.filtros });
      setElementos(response.elementos);
      setCantidad(response.cantidad);
      setPage(response.page);
      setLimit(params?.filtros?.limit ?? DEFAULT_LIMIT_PAGINATION);
    } catch (err) {
      showErrorToast("No fue posible cargar las certificaciones");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModalABM(false);
    setTimeout(() => setActionType(undefined), 500);
  };

  const handleEdit = (elemento: CertificacionI) => {
    setActionType("edit");
    setSelectedElement(elemento);
    setShowModalABM(true);
  };

  const handleCreate = () => {
    setActionType("create");
    setShowModalABM(true);
  };

  const handleChangePagination = (newFiltros: {
    [key: string]: string | number;
  }) => {
    searchOrientaciones({ filtros: { ...values, ...newFiltros } });
  };

  const handleClearFilters = () => {
    resetForm();
    searchOrientaciones();
  };

  const handleChangeWithResetPage = (pageOne: any) => {
    setPage(1);
    handleChange(pageOne);
  };

  const refreshTable = () => {
    setPage(1);
    searchOrientaciones({ filtros: { ...values, page: 1 } });
  };

  const renderActions = (elemento: CertificacionI) => {
    return (
      <CertificacionesRowActions
        elemento={elemento}
        onClickEdit={handleEdit}
        refreshTable={refreshTable}
      />
    );
  };

  useEffect(() => {
    searchOrientaciones({ filtros: { ...values, limit, page } });
  }, [values]);

  return (
    <section>
      <h1 className="section-title">Certificaciones</h1>

      <h2 className="section-subtitle mt-2">
        Desde acá podrás gestionar las certificaciones.
      </h2>

      <div className="d-flex justify-content-between mt-4 mb-3">
        <div className="d-flex column-gap-3">
          <Input
            size="sm"
            id="nombre"
            onChange={handleChangeWithResetPage}
            placeholder="Buscar"
            values={values}
            startIcon={<LupaIcon />}
          />
          <Button
            size="sm"
            variant="secondary"
            className="clear-filters-button"
            onClick={handleClearFilters}
          >
            Limpiar filtros
          </Button>
        </div>
        <Button size="lg" onClick={handleCreate}>
          Nueva certificación
        </Button>
        <CertificacionesABM
          showModal={showModalABM}
          actionType={actionType}
          onClose={handleCloseModal}
          elemento={selectedElement}
          onSuccess={refreshTable}
        />
      </div>

      {isLoading && (
        <div className="d-flex justify-content-center w-full">
          <Spinner />
        </div>
      )}

      {!isLoading && elementos && cantidad != undefined && (
        <>
          <CertificacionesTable
            elementos={elementos}
            renderActions={renderActions}
          />
          <Pagination
            totalItems={cantidad}
            currentPage={page}
            currentLimit={limit}
            onChangePage={handleChangePagination}
            showPaginationOnlyOnMoreThanPages={1}
          />
        </>
      )}
    </section>
  );
};
